<template>
  <custom-callout
    controlled
    :opened="value.opened"
    @click:open="toggle()"
    border-color="gray"
    class="my-3"
  >
    <div class="row">
      <div class="col-6 col-sm">
        <span class="body-2 text-gray font-weight-normal text-mobile">
          Año Académico:
        </span>
        <p class="body-1 font-weight-bold text-mobile">
          {{ value.academicYearName }}
        </p>
      </div>
      <div class="col-6 col-sm">
        <span class="body-2 text-gray font-weight-normal text-mobile">
          Región:
        </span>
        <p class="body-1 font-weight-normal text-mobile">
          {{ value.regionName }}
        </p>
      </div>
      <div class="col-6 col-sm">
        <span class="body-2 text-gray font-weight-normal text-mobile">
          Centro:
        </span>
        <p class="body-1 font-weight-normal text-mobile">
          {{ value.centerName }}
        </p>
      </div>
      <div class="col-6 col-sm">
        <span class="body-2 text-gray font-weight-normal text-mobile">
          Distrito:
        </span>
        <p class="body-1 font-weight-normal text-mobile">
          {{ value.districtName }}
        </p>
      </div>
      <div class="col-6 col-sm">
        <span class="body-2 text-gray font-weight-normal text-mobile">
          Municipio:
        </span>
        <p class="body-1 font-weight-normal text-mobile">
          {{ value.municipalityName }}
        </p>
      </div>
      <div :class="['col-6 col-sm mb-3', { 'pt-2': isMobile }]">
        <div :style="{ width: isMobile ? '62px' : '120px' }">
          <custom-balloon
            :background-color="
              `${value.deleteFlag == 0 ? 'bg--green' : ' bg-brown'}`
            "
            :class="['mt-2 py-1 px-0', { 'mt-2': isMobile }]"
            :text="value.deleteFlag == 0 ? 'Activa' : 'Inactiva'"
          />
        </div>
      </div>
      <div v-if="showActions" class="col-12 col-sm">
        <drop-down
          class="mt-2"
          :class="isMobile ? 'mr-3' : ''"
          :items="actions"
        />
      </div>
    </div>
    <template #edition>
      <div class="p-2">
        <div class="px-4 mx-1 bg-white">
          <div class="row pt-2">
            <div class="col-md col-12">
              <span class="body-2 text-gray font-weight-normal text-mobile">
                Tipo de Ambiente Educativo:
              </span>
              <p class="body-1 font-weight-bold text-mobile">
                {{ value.educationalEnvironmentTypeName | empty }}
              </p>
            </div>
            <div class="col-md col-12">
              <span class="body-2 text-gray font-weight-normal text-mobile">
                Nivel:
              </span>
              <p class="body-1 font-weight-normal text-mobile">
                {{ value.schoolLevelTypeName | empty }}
              </p>
            </div>
            <div class="col-md col-12">
              <span class="body-2 text-gray font-weight-normal text-mobile">
                ¿Cuenta con transportación Regular?:
              </span>
              <p class="body-1 font-weight-normal text-mobile">
                {{ value.hasRegularTransport | bool }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import DropDown from 'dropdown';
import CustomCallout from 'custom-callout';
import schoolApi from '@/modules/school-management/api';
import mixAlert from '@/mixin/alert.mixin';
import CustomBalloon from 'custom-balloon';

export default {
  name: 'ConfigurationRow',
  mixins: [mixAlert],
  components: {
    DropDown,
    CustomCallout,
    CustomBalloon,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    //TODO: refactorizar "LoadValidationMessages", para que si el mensaje ya ha
    //sido cargado, no vuelva a hacer la llamada a la api
    resources: {
      type: [Object, Array],
      default: () => [],
    },
  },
  filters: {
    bool(value) {
      if (![true, false].includes(value)) return '-';
      return value ? 'Sí' : 'No';
    },
  },
  data() {
    return {
      section: null,
    };
  },
  computed: {
    mapEdit() {
      return {
        year: {
          id: this.value.academicYearId,
          description: this.value.academicYearName,
        },
        region: {
          id: this.value.regionId,
          name: this.value.regionName,
        },
        center: {
          id: this.value.centerId,
          name: this.value.centerName,
        },
        district: {
          id: this.value.districtId,
          name: this.value.districtName,
        },
        municipality: {
          id: this.value.municipalityId,
          name: this.value.municipalityName,
        },
        educationalEnvironmentType: {
          id: this.value.educationalEnvironmentTypeId,
          name: this.value.educationalEnvironmentTypeName ?? '',
        },
        schoolLevelType: {
          id: this.value.schoolLevelTypeId,
          name: this.value.schoolLevelTypeName ?? '',
        },
        deleteFlag: this.value.deleteFlag,
        hasRegularTransport: this.value.hasRegularTransport,
        opened: this.value.opened,
      };
    },
    showActions() {
      return this.$store.getters.HasPermission('school.yearconfig.edit');
    },
    actions() {
      return [
        {
          label: 'Información adicional',
          icon: 'fas fa-info-circle text-green',
          click: () => this.toggle(this.sections.AdditionalInfo, false),
        },
        {
          label: 'Editar',
          icon: 'fas fa-edit text-green',
          click: () => this.$emit('on-edit', this.mapEdit),
        },
        {
          label: 'Inactivar',
          icon: 'fas fa-empty-set text-green',
          visible: this.value.deleteFlag == '0',
          click: this.inactivate,
        },
        {
          label: 'Activar',
          icon: 'fas fa-school text-green',
          visible: this.value.deleteFlag == '1',
          click: this.activate,
        },
      ];
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    additionalInfoSelected() {
      return this.section == this.sections.AdditionalInfo;
    },
    sections() {
      return Object.freeze({
        AdditionalInfo: 0,
        Edit: 1,
      });
    },
  },
  methods: {
    async activate() {
      const message = (this.resources['24014'] || '').replace(
        '{0}',
        this.value.academicYearName
      );
      const answer = await this.ShowCancelModal('Confirmación', message);
      if (answer) {
        try {
          const payload = {
            ...this.value,
            deleteFlag: '0',
          };

          await schoolApi.configYearStatus(payload);

          this.value.deleteFlag = '0';
          this.$emit('on-delete-flag', '0');
        } catch (err) {
          this.ShowToast('', err.response.data.message, 'error');
        }
      }
    },
    async inactivate() {
      const message = (this.resources['24013'] || '').replace(
        '{0}',
        this.value.academicYearName
      );
      const answer = await this.ShowCancelModal('Confirmación', message);
      if (answer) {
        try {
          const payload = {
            ...this.value,
            deleteFlag: '1',
          };

          await schoolApi.configYearStatus(payload);

          this.value.deleteFlag = '1';
          this.$emit('on-delete-flag', '1');
        } catch (err) {
          this.ShowToast('', err.response.data.message, 'error');
        }
      }
    },
    toggle(section, toggle = true) {
      this.section = section ?? this.sections.AdditionalInfo;
      if (toggle) this.value.opened = !this.value.opened;
      else this.value.opened = true;
    },
  },
};
</script>

<style scoped>
::v-deep .custom-class {
  background-color: transparent !important;
}

::v-deep #dropdownMenuButton {
  background-color: transparent !important;
}

@media only screen and (max-width: 375px) {
  .text-mobile {
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep #dropdownMenuButton {
    width: 100% !important;
  }

  ::v-deep .dropdown button {
    font-size: 12px !important;
    width: 100% !important;
    height: 32px;
    padding: 1px;
  }

  ::v-deep .rounded-pill {
    margin-top: 10px !important;
    height: 24px;
    padding: 2px !important;
    font-size: 12px;
  }

  ::v-deep .collaut-container {
    padding: 15px !important;
  }
}
</style>
